import React from "react";
import { InfoAlert } from "src/components/InfoAlert";
import { RenderMediaContent } from "src/components/RenderMediaContent";

// Placeholder video - replace with actual video when available
const deckInspectorVideo = "https://www.youtube.com/watch?v=jZTXlMQuTlA";

export const DeckInspector: React.FC = () => {
  return (
    <div className="flex flex-col gap-6 px-4">
      <section className="flex flex-col gap-3">
        <p>
          Upload and analyze your SAMMI deck JSON files
          completely offline, without connecting to SAMMI.
        </p>
        <InfoAlert message="This feature is completely free for all users (Windows only)." />
        <p>
          Filter buttons by ID, label, triggers, commands, and even their contents. 
          This feature is <strong>completely free for all users</strong> (Windows only).
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <RenderMediaContent src={deckInspectorVideo} />
      </section>

      <section className="flex flex-col gap-3">
        <h3 className="text-lg font-semibold">How to Use</h3>
        <ol className="list-decimal space-y-2 pl-6">
          <li>
            Open Deck Hopper and navigate to the <b>Inspector</b> in menu, and switch to the <b>Deck Inspector</b> tab.
          </li>
          <li>
            Click <b>Upload Deck JSON</b> and select your SAMMI deck file. A single deck file, or a `decks_data.json` files are supported.
          </li>
          <li>
            Use the filter options to search by button ID, label, triggers, commands, or content.
          </li>
          <li>
            View detailed information about each button, and press 'Edit Button' to open it directly in SAMMI Core.
          </li>
        </ol>
      </section>
    </div>
  );
};

export default DeckInspector;
